export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14973.b266685d.jpg";